// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// 2026-08 AU版基盤（Phase 1）：REACT_APP_*環境変数が設定されていればそれを使い、
// 未設定なら必ず日本版の既存ハードコード値にフォールバックする。
// これにより、REACT_APP_*を一切設定しない既存のビルド手順（npm run build /
// npm run build:v20）は100%これまで通り日本版Firebaseプロジェクト
// （sumaho01-4ce70、asia-northeast1）へ接続する。AU版ビルドは別途
// .env.au 等でREACT_APP_FIREBASE_*・REACT_APP_FUNCTIONS_REGIONを
// 明示的に指定した場合のみ有効になる（詳細はAU_SETUP.mdを参照）。
// JP/AU接続先のクロス（AUビルドがJP Firebaseへ、JPビルドがAU Firebaseへ
// 誤接続すること）を防ぐため、フォールバック値は既存の日本版値のみとし、
// AU版の値をこのファイルにハードコードすることはしない
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAADx92K1_IQiXxkPNVTqmA_WFwpSuUfv4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sumaho01-4ce70.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sumaho01-4ce70",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sumaho01-4ce70.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "952303733286",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:952303733286:web:254418969a24699f4274e7",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-14QMLLNT0V",
};

// market識別子。REACT_APP_MARKET未設定時は"jp"（既存動作）。
// AU版ビルドはREACT_APP_MARKET=auを明示的に指定する
export const MARKET = (process.env.REACT_APP_MARKET || "jp").toLowerCase();

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Functionsリージョンも同様にmarket別切替（未設定時は既存のasia-northeast1）
export const functions = getFunctions(app, process.env.REACT_APP_FUNCTIONS_REGION || "asia-northeast1");
